import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { mockIntegrationData } from '../../../../api/integrationsMockData';
import { useIntegrationsMetadata, useListIntegrationSpecs, useUserRole } from '../../../../api/query';
import { IntegrationPageView } from '../../../../pages';

const DEFAULT_INTEGRATIONS_META_DATA = { integrationsMetadata: undefined };
const DEFAULT_INTEGRATIONS_DATA = { integrationSpecs: [] };

const IntegrationPage = () => {
  const { integration, authenticatedUserEmail } = Route.useLoaderData();
  const {
    data: integrationSpecsData,
    isLoading: isIntegrationsLoading,
    isFetching: isIntegrationsFetching,
    isError: isIntegrationsError,
    isLoadingError: isIntegrationsLoadingError,
  } = useListIntegrationSpecs();
  const {
    data,
    isFetching: isIntegrationsMetadataFetching,
    isLoading: isIntegrationsMetadataLoading,
    isError: isIntegrationsMetadataError,
    isLoadingError: isIntegrationsMetadataLoadingError,
  } = useIntegrationsMetadata();
  const { data: userAccessRole } = useUserRole(authenticatedUserEmail);

  const { integrationsMetadata } = data?.data ?? DEFAULT_INTEGRATIONS_META_DATA;
  const { integrationSpecs } = integrationSpecsData ?? DEFAULT_INTEGRATIONS_DATA;
  const userRole = userAccessRole?.data?.role;

  //TODO: Remove this useMemo after api response return multiple data
  const integrationsData = useMemo(() => [...(integrationSpecs ?? []), ...mockIntegrationData], [integrationSpecs]);

  return (
    <IntegrationPageView
      integrations={integrationsData}
      integrationsMetadata={integrationsMetadata}
      currentIntegration={integration}
      userRole={userRole}
      isLoading={
        isIntegrationsMetadataLoading ||
        isIntegrationsMetadataFetching ||
        isIntegrationsLoading ||
        isIntegrationsFetching
      }
      isError={
        isIntegrationsMetadataError ||
        isIntegrationsMetadataLoadingError ||
        isIntegrationsError ||
        isIntegrationsLoadingError
      }
    />
  );
};

export const Route = createFileRoute('/_auth/integration/$integration')({
  component: IntegrationPage,
  loader: ({ params, context }) => {
    return { integration: params.integration, authenticatedUserEmail: context.user?.username };
  },
});
